import React from 'react';
import { BarChart3 } from 'lucide-react';

export const ANALYSIS_META = {
  correlation: { label: 'Correlation', icon: 'Grid3x3', color: '#2ECC71' },
  multiple_correlation: { label: 'Multiple Corr.', icon: 'Grid3x3', color: '#27AE60' },
  regression: { label: 'Regression', icon: 'TrendingUp', color: '#3498DB' },
  multiple_regression: { label: 'Multiple Reg.', icon: 'TrendingUp', color: '#2980B9' },
  cluster_analysis: { label: 'Cluster Analysis', icon: 'Dna', color: '#9B59B6' },
  d2_analysis: { label: 'D² & Cluster', icon: 'Dna', color: '#9B59B6' },
  path_analysis: { label: 'Path Analysis', icon: 'GitFork', color: '#E67E22' },
  general_analysis_enhanced: { label: 'General Analysis (Phase 1)', icon: 'GitFork', color: '#1F3A2E' },
  pca: { label: 'PCA', icon: 'Target', color: '#E74C3C' },
  discriminant_function_analysis: { label: 'DFA', icon: 'Layers', color: '#1ABC9C' },
  line_x_tester: { label: 'Line × Tester', icon: 'FlaskConical', color: '#C0392B' },
  diallel_griffing: { label: 'Diallel', icon: 'FlaskConical', color: '#8E44AD' },
  hayman_wr_vr: { label: 'Hayman Wr-Vr', icon: 'FlaskConical', color: '#2C3E50' },
  triple_test_cross: { label: 'TTC', icon: 'FlaskConical', color: '#D35400' },
  crd_analysis: { label: 'CRD', icon: 'BarChart3', color: '#27AE60' },
  rbd_analysis: { label: 'RBD', icon: 'BarChart3', color: '#2980B9' },
  nc_design_i: { label: 'NC Design I', icon: 'FlaskConical', color: '#8E44AD' },
  eberhart_russell_stability: { label: 'Eberhart-Russell', icon: 'TrendingUp', color: '#F39C12' },
  eberhart_russell: { label: 'Eberhart-Russell', icon: 'TrendingUp', color: '#F39C12' },
  ammi: { label: 'AMMI', icon: 'Target', color: '#16A085' },
  met_analysis: { label: 'MET Analysis', icon: 'TrendingUp', color: '#2980B9' },
  outlier_detection: { label: 'Outlier Detection', icon: 'BarChart3', color: '#E74C3C' },
  rbd_factorial_1: { label: 'RBD Factorial I', icon: 'FlaskConical', color: '#9B59B6' },
  rbd_factorial_2: { label: 'RBD Factorial II', icon: 'FlaskConical', color: '#E67E22' },
  rbd_factorial_3: { label: 'RBD Factorial III', icon: 'FlaskConical', color: '#E74C3C' },
  split_plot: { label: 'Split-Plot', icon: 'Layers', color: '#0D9488' },
  augmented: { label: 'Augmented', icon: 'Target', color: '#B45309' },
  htp_analysis: { label: 'HTP', icon: 'BarChart3', color: '#0EA5E9' },
  molecular_phase1: { label: 'Molecular — Phase 1 QC', icon: 'Dna', color: '#0891B2' },
  molecular_qtl: { label: 'Molecular — Phase 2 QTL Mapping', icon: 'Dna', color: '#6366F1' },
  molecular_gwas: { label: 'Molecular — Phase 3 GWAS', icon: 'Dna', color: '#8B5CF6' },
  molecular_genomic_selection: { label: 'Molecular — Phase 4 Genomic Selection', icon: 'Dna', color: '#7C3AED' },
  molecular_breeding: { label: 'Molecular', icon: 'Dna', color: '#7C3AED' },
  nc_design_ii: { label: 'NC Design II', icon: 'GitFork', color: '#DC2626' },
  augmented_design: { label: 'Augmented', icon: 'Target', color: '#B45309' },
  gge_biplot: { label: 'GGE Biplot', icon: 'TrendingUp', color: '#4F46E5' },
  heritability_ga: { label: 'Heritability & GA', icon: 'Dna', color: '#0E7490' },
  selection_index: { label: 'Selection Index', icon: 'Target', color: '#7C3AED' },
  non_parametric: { label: 'Non-Parametric Tests', icon: 'BarChart3', color: '#B45309' },
  diversity: { label: 'Diversity Analysis', icon: 'Dna', color: '#059669' },
  strip_plot: { label: 'Strip Plot', icon: 'Layers', color: '#0D9488' },
  latin_square: { label: 'Latin Square', icon: 'BarChart3', color: '#2563EB' },
  alpha_lattice: { label: 'Alpha Lattice', icon: 'Target', color: '#7C3AED' },
  missing_plot: { label: 'Missing Plot', icon: 'BarChart3', color: '#DC2626' },
  strip_split_plot: { label: 'Strip-Split Plot', icon: 'Layers', color: '#0D9488' },
  bib_design: { label: 'BIB Design', icon: 'BarChart3', color: '#B45309' },
  nested_design: { label: 'Nested Design', icon: 'Layers', color: '#6B46C1' },
  nc_design_iii: { label: 'NC Design III', icon: 'FlaskConical', color: '#6B46C1' },
  generation_mean: { label: 'Generation Mean', icon: 'FlaskConical', color: '#B45309' },
  pooled_anova: { label: 'Pooled ANOVA', icon: 'Layers', color: '#059669' },
  full_met: { label: 'Full MET', icon: 'TrendingUp', color: '#059669' },
  genotype_year: { label: 'GxY Analysis', icon: 'TrendingUp', color: '#059669' },
  manova_enhanced: { label: 'MANOVA (Enhanced)', icon: 'Target', color: '#EA580C' },
  mutation_dose_response: { label: 'Mutagenic Dose Response', icon: 'Atom', color: '#B45309' },
  mutation_ld50_gr50: { label: 'LD50 & GR50', icon: 'Atom', color: '#B45309' },
  mutation_frequency: { label: 'Mutation Frequency', icon: 'Atom', color: '#B45309' },
  mutation_spectrum: { label: 'Mutant Spectrum', icon: 'Atom', color: '#B45309' },
  mutation_m2_generation: { label: 'M2 Generation', icon: 'Atom', color: '#B45309' },
  mutation_chlorophyll: { label: 'Chlorophyll Mutation', icon: 'Atom', color: '#B45309' },
  mutation_quantitative: { label: 'Quantitative Mutation', icon: 'Atom', color: '#B45309' },
  mutation_rate: { label: 'Mutation Rate', icon: 'Atom', color: '#B45309' },
  mutation_comparative: { label: 'Comparative Mutagen', icon: 'Atom', color: '#B45309' },
  mutation_m3_progeny: { label: 'M3 Progeny Test', icon: 'Atom', color: '#B45309' },
  mutation_screening_index: { label: 'Screening Index', icon: 'Atom', color: '#B45309' },
  disease_audpc: { label: 'AUDPC', icon: 'Shield', color: '#991B1B' },
  disease_infection_type: { label: 'Infection Type', icon: 'Shield', color: '#991B1B' },
  disease_yield_correlation: { label: 'Disease × Yield', icon: 'Shield', color: '#991B1B' },
  disease_virulence_frequency: { label: 'Virulence Frequency', icon: 'Shield', color: '#991B1B' },
  disease_screening_summary: { label: 'Resistance Screening', icon: 'Shield', color: '#991B1B' },
};

export const NAV_GROUPS = [
  { id: 'association', label: 'Association Analysis', color: '#27AE60', keys: ['correlation', 'multiple_correlation', 'regression', 'multiple_regression', 'path_analysis', 'general_analysis_enhanced'] },
  { id: 'multivariate', label: 'Multivariate Analysis', color: '#9B59B6', keys: ['pca', 'd2_analysis', 'htp_analysis', 'discriminant_function_analysis'] },
  // Molecular Analysis intentionally NOT shown on the Results page — it
  // has its own dedicated top-nav tab (`/molecular-genetics`). Section
  // results for `diversity` / `molecular_breeding`, if present, fall
  // through to the "Other" ungrouped tab list. (Niranjan, Feb 2026)
  { id: 'design', label: 'Experimental Design', color: '#2980B9', keys: ['crd_analysis', 'rbd_analysis', 'split_plot', 'augmented', 'augmented_design', 'rbd_factorial_1', 'rbd_factorial_2', 'rbd_factorial_3', 'strip_plot', 'latin_square', 'alpha_lattice', 'missing_plot', 'strip_split_plot', 'bib_design', 'nested_design'] },
  { id: 'mating', label: 'Mating & Combining Ability', color: '#8E44AD', keys: ['line_x_tester', 'diallel_griffing', 'hayman_wr_vr', 'triple_test_cross', 'nc_design_i', 'nc_design_ii', 'nc_design_iii', 'generation_mean'] },
  { id: 'stability', label: 'Stability & MET', color: '#F39C12', keys: ['eberhart_russell_stability', 'eberhart_russell', 'ammi', 'gge_biplot', 'met_analysis', 'pooled_anova', 'full_met', 'genotype_year'] },
  { id: 'multivariate_ext', label: 'Multivariate Extended', color: '#EA580C', keys: ['manova_enhanced'] },
  { id: 'mutation', label: 'Mutation Analysis', color: '#B45309', keys: [
    'mutation_dose_response', 'mutation_ld50_gr50', 'mutation_frequency', 'mutation_spectrum',
    'mutation_m2_generation', 'mutation_chlorophyll', 'mutation_quantitative', 'mutation_rate',
    'mutation_comparative', 'mutation_m3_progeny', 'mutation_screening_index',
  ]},
  { id: 'disease', label: 'Disease Resistance', color: '#991B1B', keys: [
    'disease_audpc', 'disease_infection_type', 'disease_yield_correlation',
    'disease_virulence_frequency', 'disease_screening_summary',
  ]},
  { id: 'genetic', label: 'Genetic Parameters', color: '#0E7490', keys: ['heritability_ga', 'selection_index', 'non_parametric'] },
];

export function getMeta(key) {
  const raw = ANALYSIS_META[key];
  if (!raw) return { label: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), icon: BarChart3, color: '#6B8E7B' };
  // Return with resolved icon
  return { ...raw, icon: BarChart3 }; // Icon resolution happens in parent
}
